// extracted by mini-css-extract-plugin
export default {"mobile":"_3QFpU","root":"_28Siz","onImage":"_2q81o"};